<template>
  <div class="upload-drop-base pa-4">
    <div class="fonts-s16 fonts-600 fonts-color-dark custom-m-y12">
      {{ title }}
    </div>
    <div
      class="upload-container"
      @click="handleClick"
      @dragover.prevent="isDragging = true"
      @dragleave.prevent="isDragging = false"
      @drop.prevent="handleDrop"
      :class="{ dragging: isDragging }"
    >
      <input
        ref="fileInput"
        type="file"
        :accept="accept"
        :disabled="disabled"
        :multiple="multiple"
        @change="handleFiles($event.target.files)"
        style="display: none"
      />

      <div class="preview-zone pa-4">
        <template v-if="files.length">
          <div
            v-for="(file, i) in files"
            :key="i"
            class="file-preview d-flex gp-4"
          >
            <v-avatar size="40" class="mr-4"><v-icon class="icon-tam-20">{{ iconResponse }}</v-icon></v-avatar>
            <div class="flex-grow-1  min-w-0">
              <p class="ma-0 fonts-s14 fonts-500 fonts-color-dark1 text-truncate">{{ file.name }}</p>
              <p class="ma-0 fonts-s12 fonts-400 fonts-color-gray3">{{ formatSize(file.size) }}</p>
            </div>
            <div><v-icon>$circleCheckIcon</v-icon></div>
          </div>
        </template>

        <template v-else>
          <div class="d-flex flex-column gp-12 align-center">
            <v-icon color="white" size="32">{{ prependIcon }}</v-icon>
            <p class="mb-0 fonts-s12 fonts-600 fonts-family-poppins fonts-color-purple">
              Toca para subir un archivo
            </p>
            <p class="mb-0 fonts-s12 fonts-400 fonts-family-poppins fonts-color-gray3">
              {{ detailText }}
            </p>
          </div>
        </template>
      </div>

      <v-messages
        v-if="errorMessages && errorMessages.length"
        :value="errorMessages"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: "UploadProfile",

  props: {
    title: { type: String, default: "Upload" },
    detailText: { type: String, default: "SVG, PNG, JPG o GIF (max. 800x400px)" },
    disabled: { type: Boolean, default: false },
    iconResponse: { type: String, default: "$filePngIcon" },
    onSelectedPicture: { type: Function },
    errorMessages: { type: Array, default: () => [] },
    accept: { type: String, default: "image/png, image/jpeg, image/jpg" },
    prependIcon: { type: String, default: "$uploadDropIcon" },
    multiple: { type: Boolean, default: false },
  },

  data() {
    return {
      files: [],
      isDragging: false,
    };
  },

  methods: {
    handleClick() {
      if (this.disabled) return;
      this.$refs.fileInput?.click();
    },

    handleDrop(e) {
      if (this.disabled) return;
      this.isDragging = false;
      this.handleFiles(e.dataTransfer.files);
    },

    handleFiles(fileList) {
      const fileArray = Array.from(fileList);
      this.files = fileArray;

      if (!this.multiple) {
        this.onSelectedPicture?.(fileArray[0]);
      } else {
        this.onSelectedPicture?.(fileArray);
      }
    },

    formatSize(bytes) {
      if (bytes < 1024) return bytes + " B";
      if (bytes < 1024 * 1024) return (bytes / 1024).toFixed(1) + " KB";
      return (bytes / 1024 / 1024).toFixed(2) + " MB";
    },
  },
};
</script>

